import { Event } from './Event'
import { SimpleIdentity } from './Identity'
import { Location, Position } from './Event'

export enum ShiftRecurrenceState {
  UNASSIGNED = 'UNASSIGNED',
  UNDER_ASSIGNED = 'UNDER_ASSIGNED',
  FULLY_ASSIGNED = 'FULLY_ASSIGNED',
  OVER_ASSIGNED = 'OVER_ASSIGNED',
}

export enum ShiftSpotState {
  UNASSIGNED = 'UNASSIGNED',
  ASSIGNED = 'ASSIGNED',
  UNASSIGNABLE = 'UNASSIGNABLE',
}

export enum IntervalTimeContext {
  PUNCH_CLOCK = 'PUNCH_CLOCK',
  MANUAL = 'MANUAL',
}

export enum PunchType {
  CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT',
  BREAK_START = 'BREAK_START',
  BREAK_END = 'BREAK_END',
}

export enum ShiftSpotPunchClockState {
  PENDING = 'PENDING',
  CHECKED_IN = 'CHECKED_IN',
  BREAK = 'BREAK',
  CHECKED_OUT = 'CHECKED_OUT',
  LATE = 'LATE',
  MISSED = 'MISSED',
  ERROR = 'ERROR',
}

export interface EventSchedule extends Event {
  shifts: Array<Shift>
}

export interface Shift {
  id: number
  dateCreated: Date

  beginTime: string
  endTime: string
  spotsToFill: number

  location: Location
  position: Position

  notes: string

  recurrences: Array<ShiftRecurrence>
}

export interface ShiftRecurrence {
  id: number
  dateCreated: Date

  state: ShiftRecurrenceState
  date: string

  spots: Array<ShiftSpot>
}

export interface ShiftSpot {
  id: number
  dateCreated: Date
  lastUpdated?: Date

  state: ShiftSpotState
  hadBreak: boolean

  fulfilledBy?: SimpleIdentity
  unassignable: boolean
  notes: string
  shiftNotes: string

  punchClockState?: ShiftSpotPunchClockState
  punchClock?: PunchClock
}

export interface ShiftSpotContext {
  shift: Shift
  recurrence: ShiftRecurrence
  shiftSpot: ShiftSpot | null
}

export interface PunchClock {
  punchState: ShiftSpotPunchClockState
  inAndOut: Interval<Date>
  breaks: Array<BreakInterval>
  punches: Array<PunchClockPunch>
}

export interface Interval<DT> {
  checkIn: DT
  checkInContext: IntervalTimeContext
  checkOut: DT
  checkOutContext: IntervalTimeContext
}

// NOTE: BREAK TIMES ARE IN UTC SINCE THEY REPRESENT AN ACTUAL TIME THAT SOMETHING
// HAPPENED. SHIFTS TIMES ARE NOT IN UTC.
export interface BreakInterval extends Interval<string> {
  id: number
}

export interface PunchClockPunch {
  id: number
  supervisor: SimpleIdentity
  dateCreated: Date
  scanTime: Date
  punchTime: Date
  notes: string
  punchType: PunchType
}

export const PunchTypeFriendlyName = (type: PunchType): string => {
  switch (type) {
    case PunchType.CHECK_IN:
      return 'Check In'
    case PunchType.CHECK_OUT:
      return 'Check Out'
    case PunchType.BREAK_START:
      return 'Break Start'
    case PunchType.BREAK_END:
      return 'Break End'
    default:
      return '?'
  }
}

export interface ShiftSummarySpot {
  id: number
  date: string | number
  startTime: string | number
  endTime: string | number
  location: string
  position: string
  eventName: string
  eventId: number
  state: ShiftSpotState
  punchClockState: ShiftSpotPunchClockState
  hadBreak: boolean
  notes: string
  shiftNotes: string
}
